module.exports = __webpack_public_path__ + "static/media/timesheet_submission1.3db9fdec.png";